import styled from '@emotion/styled'

export const AttachedContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  
  > * {
    pointer-events: auto;
  }
`

export const FileList = styled.div`
  position: absolute;
  bottom: 50px;
  left: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: calc(100% - 32px);
  z-index: 1;
`

export const FileBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  background-color: #F0FAF6;
  border: 2px dashed #00A86B;
  border-radius: 6px;
  max-width: 250px;
`

export const AttachButton = styled.div`
  position: absolute;
  bottom: 15px;
  left: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1;
  color: #666;
  transition: opacity 0.2s;
  cursor: pointer;
`
